import axios from 'axios';

// Função para buscar os dados da API do SheetDB
export async function fetchProducts() {
  try {
    const response = await axios.get(
      'https://sheetdb.io/api/v1/weo6pmj20ic5c?sheet=Personal%20Care'
    );
    const rawData = response.data;
    console.log('Dados recebidos da planilha:', rawData);

    const products = rawData.map(item => ({
      name: item["Producto (Nombre comercial)"],
      inci: item["INCI"],
      sector: item["Función"],
      subsector: item["Función"],
      description: item["Descripción"],
      characteristics: item["Características - short"],
      benefits: item["Beneficios - short"],
      applications: item["Aplicaciones - short"],
      fullApplications: item["Aplicaciones"],
      webLink: item["Link página web"],
    }));

    return products;
  } catch (error) {
    console.error("Erro ao buscar dados da planilha:", error);
    return [];
  }
}
